import errorHandle from '../../../utils/errorHandle';
import { getDateDetailsFun, getDetailsFun } from '../../../api/infoOrgApi';

export default async function fetchTripData(type, packId, setLoading, setPackData, setPackDates) {
    setLoading(true);
    console.log(type, packId);
    try {
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await Promise.all([await getDetailsFun(type, packId), await getDateDetailsFun(type, packId)]);
        const sortedDates = allData[1].data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        setPackData(allData[0].data);
        setPackDates(sortedDates);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
